import {WinPresentationInitialState} from '@fantasmagames/slot/src/modules/winpresentation/states/WinPresentationInitialState';

export class WinPresentationInitialBeforeBigWin extends WinPresentationInitialState {

}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/winpresentation/states/WinPresentationInitialBeforeBigWin.ts